import { render } from "./bi.vue?vue&type=template&id=510cdca7&scoped=true"
import script from "./bi.vue?vue&type=script&lang=js"
export * from "./bi.vue?vue&type=script&lang=js"

import "./bi.vue?vue&type=style&index=0&id=510cdca7&scoped=true&lang=css"

import exportComponent from "/Users/dudgh/git/project/fognet/admin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510cdca7"]])

export default __exports__